import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import ProfileIcon from "../ProfileIcon/ProfileIcon";
// import PunchIn from "./PunchIn";
import NotificationCenter from "../Notifications/NotificationCenter";
import "./Navbar.scss";
import DefaultLogo from "../../assets/hrlabs-logo.png";
import DefaultProfileIcon from "../../Images/user-1.jpg";
import FAQModal from "../FAQModal/FAQModal";

const Navbar = ({ onNotificationReceived }) => {
  // ADD THIS PROP
  // --- STATE MANAGEMENT ---
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isFAQOpen, setIsFAQOpen] = useState(false);

  const [menuState, setMenuState] = useState({
    isSearchExpanded: false,
    isPunchIn: false,
    openDropdown: null,
    quickAccessOpen: false,
  });
  const [searchQuery, setSearchQuery] = useState("");

  // --- DERIVED DATA from AuthContext ---
  const logoImageSrc =
    user?.logo && user?.logoType
      ? `data:${user.logoType};base64,${user.logo}`
      : DefaultLogo;
  const profileImageSrc =
    user?.profileImage && user?.profileImageType
      ? `data:${user.profileImageType};base64,${user.profileImage}`
      : DefaultProfileIcon;
  const companyName = user?.companyName || "HRLabs";
  const employeeName = user?.employeeName || "Employee";
  const role = user?.role || "No Role Assigned";
  const authorities = user?.authorities || [];

  // --- MENU ITEMS & SEARCH ---
  const filteredMenuItems = [
    { name: "Apply Leave", route: "/ess/apply-leave" },
    { name: "My Leave", route: "/ess/my-leave" },
    { name: "Fallback", route: "/ess/fallback" },
    { name: "List of Holidays", route: "/ess/list-of-holidays" },
    { name: "My Logs", route: "/ess/my-logs" },
    { name: "Policies", route: "/ess/policies" },
  ].filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  // --- EVENT HANDLERS ---
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleNotificationNavigation = (section) => {
    switch (section) {
      case "teams":
        navigate("/team/manage-team-leave");
        break;
      case "ess":
        navigate("/ess/my-logs");
        break;
      case "compensation":
        navigate("/compensation-benefits/payroll-report");
        break;
      case "emailAutomation":
        navigate("/email-automation");
        break;
      default:
        navigate(`/${section}`);
    }
  };

  const handleLogout = () => {
    logout();
  };

  const handlePunchInClick = () => {
    setMenuState((prevState) => ({
      ...prevState,
      isPunchIn: !prevState.isPunchIn,
    }));
  };

  const handleLogoError = (e) => {
    console.warn("Logo failed to load, falling back to default logo");
    e.currentTarget.src = DefaultLogo;
  };

  // If the user is not logged in, don't render the navbar.
  if (!user) {
    return null;
  }

  // --- RENDER ---
  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img
          src={logoImageSrc}
          alt="Company Logo"
          className="company-logo"
          onError={handleLogoError}
        />
        {/* <span className="company-name">{companyName}</span> */}
      </div>
      <div className="navbar-right">
        {/* Search Container */}
        {/* <div
          className={`search-container ${
            menuState.isSearchExpanded ? "expanded" : ""
          }`}
          onMouseEnter={() =>
            setMenuState((prev) => ({ ...prev, isSearchExpanded: true }))
          }
          onMouseLeave={() =>
            setMenuState((prev) => ({ ...prev, isSearchExpanded: false }))
          }
        >
          <input
            type="text"
            placeholder="Search..."
            id="search"
            className={`search-input ${
              menuState.isSearchExpanded ? "expanded" : ""
            }`}
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <Icon
            icon="ion:search-outline"
            className="search-icon"
            aria-label="Toggle Search"
          />
          {menuState.isSearchExpanded && filteredMenuItems.length > 0 && (
            <div className="filtered-menu">
              {filteredMenuItems.map((item) => (
                <Link
                  key={item.route}
                  to={item.route}
                  className="filtered-item"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          )}
        </div> */}
        <button
          className="navbar-faq-button"
          onClick={() => setIsFAQOpen(true)}
          aria-label="Help / FAQ"
        >
          <Icon icon="material-symbols:help-outline-rounded" />
        </button>

        {/* Notification Center - NOW PROPERLY CONNECTED */}
        <NotificationCenter
          onNavigate={handleNotificationNavigation}
          onNotificationReceived={onNotificationReceived} // Pass the handler down
        />

        {/* Quick Access Button */}
        <div
          className="quick-access-container"
          onMouseEnter={() =>
            setMenuState((prev) => ({ ...prev, quickAccessOpen: true }))
          }
          onMouseLeave={() =>
            setMenuState((prev) => ({ ...prev, quickAccessOpen: false }))
          }
        >
          {/* <button className="quick-access-button" aria-label="Quick Access">
            <Icon icon="solar:list-arrow-down-broken" />
          </button> */}
          {menuState.quickAccessOpen && (
            <div className="quick-access-menu">
              <Link to="/ess/apply-leave">Apply Leave</Link>
              <Link to="/ess/list-of-holidays">List of Holidays</Link>
              <Link to="/ess/fallback">Fallback</Link>
              {authorities.includes("ROLE_MANAGER") && (
                <>
                  <Link to="/team/mark-attendance">Mark Attendance</Link>
                  <Link to="/team/manage-team-leave">Manage Team Leave</Link>
                </>
              )}
            </div>
          )}
        </div>

        {/* Punch In/Out Button */}
        {/* <PunchIn
          className="punchin-button"
          isPunchIn={menuState.isPunchIn}
          handlePunchInClick={handlePunchInClick}
        /> */}

        {/* Profile Dropdown Menu */}
        <div
          className="profile-menu-container"
          onMouseEnter={() =>
            setMenuState((prev) => ({ ...prev, openDropdown: "profile" }))
          }
          onMouseLeave={() =>
            setMenuState((prev) => ({ ...prev, openDropdown: null }))
          }
        >
          <button className="profile-button" aria-label="Profile Menu">
            <ProfileIcon
              size="small"
              src={profileImageSrc}
              alt="Profile"
              className="profile-avatar"
            />
            <Icon icon="mdi:chevron-down" />
          </button>
          {menuState.openDropdown === "profile" && (
            <div className="profile-menu">
              <div className="profile-info">
                <ProfileIcon
                  size="medium"
                  src={profileImageSrc}
                  alt="Profile"
                />
                <div className="profile-details">
                  <div className="profile-name">{employeeName}</div>
                  <div className="profile-role">
                    <span className="role">
                      {role
                        .replace("ROLE_", "")
                        .toLowerCase()
                        .split("_")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() + word.slice(1),
                        )
                        .join(" ")}
                    </span>
                  </div>
                </div>
              </div>
              <div className="profile-options">
                <Link to="/profile">Profile</Link>
                {authorities.includes("ROLE_ADMIN") && (
                  <Link to="/subscriptions">My Subscriptions</Link>
                )}
                <Link to="/account-settings">Account Settings</Link>
                <a
                  href="#logout"
                  className="logout-a"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                >
                  Logout
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
      <FAQModal isOpen={isFAQOpen} onClose={() => setIsFAQOpen(false)} />
    </nav>
  );
};

export default Navbar;
